<template>
  <div class="main__div px-7 py-7">
    <div class="heading-text pb-2">My Memberships</div>
    <!-- tab section -->
    <div>
      <v-row no-gutters>
        <v-col cols="12" md="4" sm="6">
          <tab-component v-model="selectedTabValue" :items="tabs" />
        </v-col>
      </v-row>
    </div>
    <!-- tab section end -->

    <!-- Start Active -->
    <v-expansion-panels flat tile>
      <v-expansion-panel>
        <v-expansion-panel-header
          class="font-weight-bold text-subtitle-1"
          expand-icon=""
          @click="activeIcon = !activeIcon"
        >
          <v-row no-gutters>
            <v-col md="2" sm="2" cols="5">
              <v-icon color="black">{{
                activeIcon ? "mdi-chevron-down" : "mdi-chevron-up"
              }}</v-icon>
              Active ({{ active_items ? active_items.length : 0 }})
            </v-col>
            <v-col md="10" sm="10" cols="7" class="py-3">
              <hr class="gray" />
            </v-col>
          </v-row>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <div>
            <v-row no-gutters v-if="loading">
              <v-col cols="4" v-for="item in 3" :key="item">
                <v-skeleton-loader
                  class="skeleton-loader pa-4"
                  type="card-avatar, sentences ,actions"
                ></v-skeleton-loader>
              </v-col>
            </v-row>
            <v-row no-gutters v-else>
              <v-col
                cols="12"
                sm="4"
                class="pb-4 pr-4"
                v-for="(item, i) in active_items"
                :key="i"
              >
                <span v-if="selectedTabValue === 'Videos'">
                  <PlaylistCard
                    v-if="item.playlist"
                    :value="item.playlist"
                    :user_id="parseInt(item.playlist.profile.user)"
                  />
                  <VideoCard
                    v-else
                    :value="item.video"
                    :user_id="parseInt(item.video.profile.user)"
                  />
                </span>
                <span v-else>
                  <membership-card :data="item" />
                </span>
              </v-col>

              <v-col
                cols="12"
                class="text-center"
                v-if="active_items ? (active_items.length > 0 ? false : true) : true"
              >
                <div class="heading-text py-4">
                  Currently you do not have any membership plan.
                </div>
              </v-col>
              <v-col cols="12" class="py-4" v-intersect="onIntersectActive">
                <div class="text-center" v-if="hide_active">
                  <v-progress-circular
                    indeterminate
                    color="#2f80ed"
                  ></v-progress-circular>
                  Loading More...
                </div>
              </v-col>
            </v-row>
          </div>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
    <!-- End Active -->

    <!-- Start Past -->
    <v-expansion-panels flat tile>
      <v-expansion-panel>
        <v-expansion-panel-header
          class="font-weight-bold text-subtitle-1"
          expand-icon=""
          @click="pastIcon = !pastIcon"
        >
          <v-row no-gutters>
            <v-col md="2" sm="2" cols="5">
              <v-icon color="black">{{
                pastIcon ? "mdi-chevron-down" : "mdi-chevron-up"
              }}</v-icon>
              Past ({{ past_items ? past_items.length : 0 }})
            </v-col>
            <v-col md="10" sm="10" cols="7" class="pt-3">
              <hr class="gray" />
            </v-col>
          </v-row>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <div>
            <v-row no-gutters v-if="loading">
              <v-col cols="4" v-for="item in 3" :key="item">
                <v-skeleton-loader
                  class="skeleton-loader pa-4"
                  type="card-avatar, sentences ,actions"
                ></v-skeleton-loader>
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col
                cols="12"
                sm="4"
                class="pb-4 pr-4"
                v-for="(item, i) in past_items"
                :key="i"
              >
                <span v-if="selectedTabValue === 'Videos'">
                  <PlaylistCard
                    v-if="item.playlist"
                    :value="item.playlist"
                    :user_id="parseInt(item.playlist.profile.user)"
                  />
                  <VideoCard
                    v-else
                    :value="item.video"
                    :user_id="parseInt(item.video.profile.user)"
                  />
                </span>
                <span v-else>
                  <membership-card :data="item" />
                </span>
              </v-col>
              <v-col
                cols="12"
                class="text-center"
                v-if="past_items ? (past_items.length > 0 ? false : true) : true"
              >
                <div class="heading-text py-4">
                  Currently you do not have any past membership plan.
                </div>
              </v-col>
              <v-col cols="12" class="py-4" v-intersect="onIntersectPast">
                <div class="text-center" v-if="hide_past">
                  <v-progress-circular
                    indeterminate
                    color="#2f80ed"
                  ></v-progress-circular>
                  Loading More...
                </div>
              </v-col>
            </v-row>
          </div>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
    <!-- End Past -->
  </div>
</template>
<script>
import apiUrl from "@/common/apiUrl";
import Axios from "@/api/BaseAxios";
import commonFunctions from "@/common/commonFunctions";

export default {
  name: "MyMembership",
  components: {
    MembershipCard: () => import("@/components/Membership/MembershipCard/MembershipCard"),
    VideoCard: () => import("@/components/VideoCourse/VideoCard/VideoCard.vue"),
    PlaylistCard: () => import("@/components/VideoCourse/PlaylistCard/PlaylistCard.vue"),
    TabComponent: () =>
      import(
        "@/components/VideoCourse/VideoAndPlaylistPage/TabComponent/TabComponent.vue"
      ),
  },
  data() {
    return {
      activeIcon: true,
      pastIcon: true,
      user_id: commonFunctions.getUserId(),
      selectedTabValue: "Groups",
      tabs: [
        { name: "Groups", value: "Groups" },
        { name: "Videos", value: "Videos" },
      ],
      loading: false,
      hide_active: false,
      hide_past: false,
      active_items: [],
      past_items: [],
      active: {
        page_number: 1,
        total_page: 1,
        item_per_page: 12,
      },
      expired: {
        page_number: 1,
        total_page: 1,
        item_per_page: 12,
      },
    };
  },
  watch: {
    async selectedTabValue() {
      (this.active = {
        page_number: 1,
        total_page: 1,
        item_per_page: 12,
      }),
        (this.expired = {
          page_number: 1,
          total_page: 1,
          item_per_page: 12,
        });
      this.loading = true;
      await this.getActiveMembershipList(true);
      await this.getExpiredMembershipList(true);
      this.loading = false;
    },
  },
  methods: {
    // getMembershipList(value, status) {
    //   status = status ? status : this.selectedTabValue;
    //   const successHandler = (res) => {
    //     if (value) {
    //       if (status === "Active") this.active_items = res.data.membership;
    //       if (status === "Expired") this.past_items = res.data.membership;
    //     } else {
    //       for (const obj of res.data.membership) {
    //         if (status === "Active")  this.active_items.push(obj);
    //         if (status === "Expired")  this.past_items.push(obj);
    //       }
    //     }
    //     if(status==="Active"){
    //       this.active.page_number = res.data.page_info.page_number;
    //       this.active.item_per_page = res.data.page_info.detail_count;
    //       this.active.total_page = res.data.page_info.total_page;
    //     } else {
    //       this.expired.page_number = res.data.page_info.page_number;
    //       this.expired.item_per_page = res.data.page_info.detail_count;
    //       this.expired.total_page = res.data.page_info.total_page;
    //     }
    //   };
    //   const failureHandler = () => {
    //   };
    //   let formData = {};
    //   formData["user_id"] = commonFunctions.getUserId();
    //   formData["status"] = status;
    //   if(status==="Active"){
    //     formData["page_number"] = this.active.page_number;
    //     formData["detail_count"] = this.active.item_per_page;
    //   }else{
    //     formData["page_number"] = this.expired.page_number;
    //     formData["detail_count"] = this.expired.item_per_page;
    //   }
    //   if(this.selectedTabValue==='Videos'){
    //     return Axios.request_GET(
    //     apiUrl.VIDEO_MY_SUBSCRIPTIONS,
    //     formData,
    //     {},
    //     successHandler,
    //     failureHandler,
    //     false,
    //     true
    //   );
    //   }else{
    //   return Axios.request_GET(
    //     apiUrl.MEMBERSHIP_API,
    //     formData,
    //     {},
    //     successHandler,
    //     failureHandler,
    //     false,
    //     true
    //   );
    //   }
    // },
    getActiveMembershipList(value) {
      const successHandler = (res) => {
        if (value) {
          this.active_items = res.data.membership;
        } else {
          for (const obj of res.data.membership) {
            this.active_items.push(obj);
          }
        }
        this.active.page_number = res.data.page_info.page_number;
        this.active.item_per_page = res.data.page_info.detail_count;
        this.active.total_page = res.data.page_info.total_page;
      };
      const failureHandler = () => {};
      let formData = {};
      formData["user_id"] = commonFunctions.getUserId();
      formData["status"] = "Active";
      formData["page_number"] = this.active.page_number;
      formData["detail_count"] = this.active.item_per_page;
      if (this.selectedTabValue === "Videos") {
        return Axios.request_GET(
          apiUrl.VIDEO_MY_SUBSCRIPTIONS,
          formData,
          {},
          successHandler,
          failureHandler,
          false,
          true
        );
      } else {
        return Axios.request_GET(
          apiUrl.MEMBERSHIP_API,
          formData,
          {},
          successHandler,
          failureHandler,
          false,
          true
        );
      }
    },
    getExpiredMembershipList(value) {
      const successHandler = (res) => {
        if (value) {
          this.past_items = res.data.membership;
        } else {
          for (const obj of res.data.membership) {
            this.past_items.push(obj);
          }
        }
        this.expired.page_number = res.data.page_info.page_number;
        this.expired.item_per_page = res.data.page_info.detail_count;
        this.expired.total_page = res.data.page_info.total_page;
      };
      const failureHandler = () => {};
      let formData = {};
      formData["user_id"] = commonFunctions.getUserId();
      formData["status"] = "Expired";

      formData["page_number"] = this.expired.page_number;
      formData["detail_count"] = this.expired.item_per_page;

      if (this.selectedTabValue === "Videos") {
        return Axios.request_GET(
          apiUrl.VIDEO_MY_SUBSCRIPTIONS,
          formData,
          {},
          successHandler,
          failureHandler,
          false,
          true
        );
      } else {
        return Axios.request_GET(
          apiUrl.MEMBERSHIP_API,
          formData,
          {},
          successHandler,
          failureHandler,
          false,
          true
        );
      }
    },
    onIntersectActive(entries) {
      const self = this;
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          self.hide_active = true;
          self.active.page_number = self.active.page_number + 1;
          if (self.active.page_number <= self.active.total_page) {
            self.getActiveMembershipList(false);
          } else {
            self.hide_active = false;
          }
        }
      });
    },
    onIntersectPast(entries) {
      const self = this;
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          self.hide_past = true;
          self.expired.page_number = self.expired.page_number + 1;
          if (self.expired.page_number <= self.expired.total_page) {
            self.getExpiredMembershipList(false);
          } else {
            self.hide_past = false;
          }
        }
      });
    },
  },
  async mounted() {
    this.loading = true;
    await this.getActiveMembershipList(true);
    await this.getExpiredMembershipList(true);
    this.loading = false;
  },
};
</script>
<style scoped>
.main__div {
  min-height: 100vh !important;
  width: 100%;
}
.heading-text {
  font-family: "Avenir";
  font-style: normal;
  font-weight: 900;
  font-size: 18px;
  line-height: 25px;
  /* identical to box height */

  color: #333333;
}
.tab {
  letter-spacing: 0px !important;
  font-weight: 900 !important;
  font-size: 16px;
  line-height: 22px;
}
.tabs {
  font-family: "Avenir";
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 22px;
  /* identical to box height */

  color: rgba(51, 51, 51, 0.74);
}
.active-tab {
  font-family: "Avenir";
  font-style: normal;
  font-weight: 900 !important;
  font-size: 16px;
  line-height: 22px;
  /* identical to box height */

  /* Primary */

  color: #2d8cff;
}
.theme--light.v-expansion-panels .v-expansion-panel {
  background-color: transparent !important;
}
</style>
